/* eslint-disable @typescript-eslint/camelcase */
// use pc sketch if the current width is bigger than 1366
// sketch refers to design sketch
// sync tt4b common ui sketch size
export const PC_SKETCH = 1366;
export const PC_LG_SKETCH = 1024;
export const PAD_SKETCH = 768;
export const MOBILE_SKETCH = 375;
export const BASE_FONTSIZE = 16;

// language
export const I18N_FALLBACK_LANG = 'en';

// cookie
export const COOKIE_LNG = 'lng_type';
export const ADS_COOKIE_LANG = 'lang_type';

// bui noticifation, message KEY
export const NOTIFICATION_KEY_NO_YESTERDAY_DATA = 'NOTIFICATION_KEY_NO_YESTERDAY_DATA';
export const MESSAGE_KEY_API_CODE_ERROR = 'MESSAGE_KEY_API_CODE_ERROR';

export const disabledSnakeFields = ['limit', 'limitField', 'limit_field'];
